import { trigger, state, style, transition, animate, keyframes, query, stagger, AnimationMetadata } from '@angular/animations';

// EXAMPLE 01 - con CLASES
export class Animations {

  constructor ( ) {}

  showEjeX( nameTrigger: string, x: string, durationIn: number, durationOut: number  ): any {
    const metaData: AnimationMetadata[] = [
      state('false', style({
        opacity: '0',
        transform: 'translateX(' + x + ')'
      })),
      state('true', style({
        opacity: '1',
        transform: 'translateX(0)'
      })),
      transition('false => true', animate(durationIn + 'ms ease-in')),
      transition('true => false', animate(durationOut + 'ms ease-out')),
  /*,
       transition('hidden <=> show', animate('900ms ease-in', keyframes([
       style({opacity: 0, transform: 'translateY(-75%)', offset: 0}),
       style({opacity: 1, transform: 'translateY(35px)',  offset: 0.5}),
       style({opacity: 1, transform: 'translateY(0)',     offset: 1.0})
       ]))),                       */
    ];
    return trigger(nameTrigger, metaData);
  }
  showEjeY( nameTrigger: string, y: string, durationIn: number, durationOut: number  ): any {
    const metaData: AnimationMetadata[] = [
      state('false', style({
        opacity: '0',
        transform: 'translateY(' + y + ')'
      })),
      state('true', style({
        opacity: '1',
        transform: 'translateY(0)'
      })),
        transition('false => true', animate(durationIn + 'ms ease-in')),
        transition('true => false', animate(durationOut + 'ms ease-out')),
        /*
       transition('hidden <=> show', animate('900ms ease-in', keyframes([
       style({opacity: 0, transform: 'translateY(-75%)', offset: 0}),
       style({opacity: 1, transform: 'translateY(35px)',  offset: 0.5}),
       style({opacity: 1, transform: 'translateY(0)',     offset: 1.0})
       ]))),                       */
    ];
    return trigger(nameTrigger, metaData);
  }                /*
  showBannerEjeY( nameTrigger: string, y: string, durationIn: number, durationOut: number  ): any {
    const metaData: AnimationMetadata[] = [
      transition('* => *', [

        // query(':enter', style({ opacity: 0 }), {optional: true}),

        query(':enter', stagger('300ms', [
          animate('.6s ease-in', keyframes([
            style({opacity: 0, transform: 'translateY(-75%)', offset: 0}),
            style({opacity: .5, transform: 'translateY(35px)',  offset: 0.3}),
            style({opacity: 1, transform: 'translateY(0)',     offset: 1.0}),
          ]))]), {optional: true})
        ,
        query(':leave', stagger('300ms', [
          animate('.6s ease-out', keyframes([
            style({opacity: 1, transform: 'translateY(0)', offset: 0}),
            style({opacity: .5, transform: 'translateY(35px)',  offset: 0.3}),
            style({opacity: 0, transform: 'translateY(-75%)',     offset: 1.0}),
          ]))]), {optional: true})
      ])
    ];
    return trigger(nameTrigger, metaData);
  }
  showBannerEjeY2( nameTrigger: string, durationIn: number, durationOut: number  ): any {
    const metaData: AnimationMetadata[] = [
      state('false', style({
        transform: 'translateY(-20%) scale(1.2,1.2)'
      })),
      state('true', style({
        transform: 'translateY(0) scale(1,1)'
      })),
      transition('false => true', animate(durationIn + 's ease-in')),
      transition('true => false', animate(durationOut + 's ease-out')),
    ];
    return trigger(nameTrigger, metaData);
  }*/
  showBannerEjeY( nameTrigger: string, durationIn: number, durationOut: number  ): any {
    const metaData: AnimationMetadata[] = [
      state('in',
        style({
          opacity: 0,
          transform: 'translateY(0)'
        })),
      transition(':enter', [
        animate('2s ease-in', keyframes([
          style({opacity: 0, transform: 'translateY(100%)  scale(.8,.8)', offset: 0}),
          style({opacity: .8, transform: 'translateY(30%) scale(1.4,1.4)', offset: 0.3}),
          style({opacity: 1, transform: 'translateY(0) scale(1,1)', offset: 1.0}),
        ]))
      ]),
      transition(':leave', [
        animate('.9s ease-out', keyframes([
          style({opacity: 1, transform: 'translateY(0)', offset: 0}),
          style({opacity: 0, transform: 'translateY(-20%)', offset: 1.0}),
        ]))
      ])
    ];
    return trigger(nameTrigger, metaData);
  }                  /*
  showEjeXRotate( nameTrigger: string, deg: string, durationIn: number, durationOut: number  ): any {
    const metaData: AnimationMetadata[] = [
      state('false', style({
        opacity: '0',
        transform: 'rotateY(' + deg + 'deg)'
      })),
      state('true', style({
        opacity: '1',
        transform: 'rotateY(0deg)'
      })),
      transition('false => true', animate(durationIn + 'ms ease-in')),
      transition('true => false', animate(durationOut + 'ms ease-out')),
    ];
    return trigger(nameTrigger, metaData);
  }
  showEjeYRotate( nameTrigger: string, deg: string, durationIn: number, durationOut: number ): any {
    const metaData: AnimationMetadata[] = [
      state('false', style({
        opacity: '0',
        transform: 'rotateX(' + deg + 'deg)'
      })),
      state('true', style({
        opacity: '1',
        transform: 'rotateX(0deg)'
      })),
      transition('false => true', animate(durationIn + 'ms ease-in')),
      transition('true => false', animate(durationOut + 'ms ease-out')),
    ];
    return trigger(nameTrigger, metaData);
  }            */
}

// EXAMPLE 02 - con FUNCIONES - add in animations 'TranslateX( 'trigger1Title','-100%', 200 )' - add in html'[@trigger1Title]= 'states';'
/*
export function Animations2( name: string, x: string, duration: number): AnimationMetadata {
  return trigger( name, [
    state('false', style({
      opacity: '0',
      transform: 'translateX(' + x + ')'
    }) ),
    state('true',  style({
      opacity: '1',
      transform: 'translateX(0)'
    }) ),
    transition('false => true', animate( duration + 'ms ease-in')),
    transition('true => false', animate( duration + 'ms ease-out')),
  ]);
}                        */

// EXAMPLE 03 - con VARIABLE - add in animations 'slideIn' - add in component class 'slideInState = 'in';'
 export const mouseEnterServices = trigger('mouseEnterServices', [
   state('false', style({
     color: 'white',
     border: '0 solid #237BCC',
     background: '#237BCC'
   })),
   state('true', style({
     border: '2px solid #237BCC',
     color: '#237BCC',
     background: 'white'
   })),
   transition('false => true', animate('250ms ease-in')),
   transition('true => false', animate('250ms ease-out'))
 ]);



// WEBPACK FOOTER //
// /home/federicblack/public_html/GrupoCristalino/src/app/animations.ts